export const relationshList = ['친구', '지인', '가족', '동료'];

export const fontsList = [
  'Noto Sans',
  'Pretendard',
  '나눔명조',
  '나눔손글씨 손편지체',
];
